module.exports = "<template>\n    <section>\n        <b-field grouped>\n            <b-input placeholder=\"Search...\"></b-input>\n            <p class=\"control\">\n                <button class=\"button is-primary\">Search</button>\n            </p>\n        </b-field>\n\n        <b-field grouped>\n            <b-input placeholder=\"Search...\" expanded></b-input>\n            <p class=\"control\">\n                <button class=\"button is-primary\">Search</button>\n            </p>\n        </b-field>\n    </section>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/field/examples/ExGroups.vue
// module id = 1395
// module chunks = 5